import React from 'react';
const EditPostContext = /*#__PURE__*/React.createContext();
const EditPostDispatchContext = /*#__PURE__*/React.createContext();
const initialEditState = {
  editReplyId: null,
  postUpdated: false,
  loadingReplies: false,
  loadingNewReply: false
};
function editPostReducer(state, action) {
  switch (action.type) {
    case 'SHOW_EDIT_POST_MODAL':
      return {
        ...state,
        editReplyId: action.payload,
        loadingReplies: true
      };
    case 'HIDE_EDIT_POST_MODAL':
      return {
        ...state,
        editReplyId: null,
        loadingReplies: false
      };
    case 'SET_POST_UPDATED':
      return {
        ...state,
        postUpdated: action.payload
      };
    case 'SET_LOADING':
      return {
        ...state,
        loadingReplies: action.payload
      };
    case 'SET_LOADING_NEW_REPLY':
      return {
        ...state,
        loadingNewReply: action.payload
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}
function EditPostProvider({
  children
}) {
  const [state, dispatch] = React.useReducer(editPostReducer, initialEditState);
  return /*#__PURE__*/React.createElement(EditPostContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(EditPostDispatchContext.Provider, {
    value: dispatch
  }, children));
}
function useEditPostState() {
  const context = React.useContext(EditPostContext);
  if (context === undefined) {
    throw new Error('useEditPostState must be used within an EditPostProvider');
  }
  return context;
}
function useEditPostDispatch() {
  const context = React.useContext(EditPostDispatchContext);
  if (context === undefined) {
    throw new Error('useEditPostDispatch must be used within an EditPostProvider');
  }
  return context;
}
export { EditPostProvider, useEditPostState, useEditPostDispatch };
//# sourceMappingURL=index.js.map